import { Box, Link, Paper } from '@material-ui/core';
import styled from 'styled-components';

export const CustomLink = styled(Link)`
  display: flex;
  text-decoration: none;
  color: #000;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

export const FooterContainer = styled(Paper)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  height: 50px;
  background-color: ${(props) => props.color || '#fff'};
`;

export const SocialMediaIconsContainer = styled(Box)`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  padding-left: 30px;
`;

export const LinksContainer = styled(Box)`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  padding-right: 30px;
`;

export const TermsAndConditionsContainer = styled(Box)`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
